import { render, staticRenderFns } from "./WsAppBarLocaleSelect.vue?vue&type=template&id=72b3b0bc&"
import script from "./WsAppBarLocaleSelect.vue?vue&type=script&lang=js&"
export * from "./WsAppBarLocaleSelect.vue?vue&type=script&lang=js&"
import style0 from "./WsAppBarLocaleSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
